export default __webpack_public_path__ + "static/media/sem3.65011d00.JPG";